
const initial = {};

export default(state = initial, action) => {
  switch(action.type) {

    default:
      return state;
  }
}